import { toast } from "react-toastify";
import Konsole from "../../utils/konsole/Konsole";
export const ErrorToast = ( message?:string ) => {
    navigator.vibrate(125) 
    toast.error(message??"Error Message", { autoClose: 1000 ,style: {
        zIndex: 10000, // Custom z-index for this toast
      },});
}

export const ErrorToastBottom = ( message?:string ) => {
    navigator.vibrate(125) 
    Konsole.log('message',message)
    // toast.error(message??"Error Message", { autoClose: 1000,position:'bottom-right' });
}
